import { Dispatch } from 'redux';

import { RootState } from '../reducers/store';
import { CustomerHallsReducerActionType } from 'src/reducers/customerHallsReducer';
import { DataToPostType } from 'src/features/Customers/Details/Hall/types';

export const LIST_CUSTOMER_HALLS = 'list_customer_halls';
export const LIST_CUSTOMER_GROUPS = 'list_customer_groups';

const GROUPS_PER_PAGE = 10;

export const listCustomerGroups =
  () =>
  (
    dispatch: Dispatch<CustomerHallsReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { get },
      customers: { customerDetail },
    } = getState();

    get(
      `/customers/${customerDetail.id}/groups?per_page=2000`,
      (response: CustomerHallsReducerActionType) => {
        response.data &&
          dispatch({
            type: LIST_CUSTOMER_GROUPS,
            payload: {
              items: response.data,
              total: response.metadata?.total_count,
            },
          });
      }
    );
  };

export const listCustomerHalls =
  (page: number) =>
  (
    dispatch: Dispatch<CustomerHallsReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { get },
      customers: { customerDetail },
    } = getState();

    get(
      `/customers/${customerDetail.id}/hall-numerics?page=${page}&per_page=${GROUPS_PER_PAGE}`,
      (response: any) => {
        response.data &&
          dispatch({
            type: LIST_CUSTOMER_HALLS,
            payload: {
              items: response.data,
              total: response.metadata?.total_count,
            },
          });
      }
    );
  };

export const addHallNumeric =
  (
    body: DataToPostType,
    successCallback: () => void,
    failureCallback: () => void
  ) =>
  async (
    dispatch: Dispatch<CustomerHallsReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { post },
      customers: { customerDetail },
    } = getState();

    post(
      '/hall-numerics',
      body,
      () => {
        listCustomerHalls(customerDetail.id)(dispatch, getState);
        successCallback();
      },
      failureCallback
    );
  };

export const updateHall =
  (
    id: string,
    body: any,
    successCallback: () => void,
    failureCallback: () => void
  ) =>
  (
    dispatch: Dispatch<CustomerHallsReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { patch },
    } = getState();

    patch(
      `/hall-numerics/${id}`,
      body,
      () => {
        listCustomerHalls(1)(dispatch, getState);
        successCallback();
      },
      () => failureCallback()
    );
  };
